import React, { useEffect, useState, FC, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { Row, Col, Input, Button, Dropdown, Spin } from "antd";
import { ReactSVG } from "react-svg";
import { SearchOutlined, CloseCircleFilled } from "@ant-design/icons";
import SideBar from "./SideBar";
import SearchCard from "./SearchCard";
import _ from "lodash";
import { CopyPageModal, FilterByModal, ConfirmationModal } from "../../Modals";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import EditBioModal from "components/Modals/EditBioModal";
import FilterIcon from "assets/SVGs/FilterIcon";
import CompassIcon from "assets/SVGs/CompassIcon";
import { RootState } from "reducers/rootReducer";
import {
  getMessageRequestPayload,
  wrapRequestPayload,
} from "../../../helpers/request/RequestPayload";
import { DashboardTabs, SocketTopics } from "constants/enums";
import { GET_AGGREGATE } from "reducers/authReducer";
import {
  getModifyPageSubscriptionTopic,
  getPageFocusSubscriptionTopic,
  getPagesSubscriptionTopic,
} from "hooks/MQTTConstants";
import { isScrollbarAtBottom } from "utils/chatUtils";
import { useMediaQuery } from "react-responsive";
import { formatUserFilterText, generateUUID } from "utils/appUtil";
import moment from "moment";

let searchTimeout;

const getStoredFilter = () => {
  try {
    return JSON.parse(localStorage.getItem("filter"));
  } catch (e) {
    return null;
  }
};

// A saved filter is applied to every page search, so it silently narrows
// results long after it was set — the search bar has to show when one is on.
const hasActiveFilter = (filter) =>
  !!filter &&
  (((filter.pageType ?? "all") !== "all") ||
    filter.readStatus?.length === 1 ||
    !!filter.userStatus ||
    !!filter.pageStatus ||
    !!filter.owner ||
    !!filter.createdAt ||
    !!filter.deleted ||
    !!filter.sort ||
    (filter.liveIoT ?? []).indexOf("Video") !== -1 ||
    (filter.liveIoT ?? []).indexOf("GPS") !== -1);

const SearchPanel: FC<{
  socket?: ISocket;
  callingPageId?: string;
  params: DashboardParams;
  selectedTab?: number;
  onPageSelection?: (item: SelectedSearchItem) => void
  onPageCreated?: () => void;
}> = ({
  socket,
  callingPageId,
  params,
  onPageSelection,
  onPageCreated,
  selectedTab,
}) => {
  const { screens, setScreens } = params;
  const { searchResult, selectedItem, searchPage, focusItem } = useSelector(
    (state: RootState) => state.search
  );
  const { findUsersToPage } = useSelector(
    (state: RootState) => state.auth
  );
  const isMobileScreen = useMediaQuery({ query: "(max-width: 700px)" });
  const dispatch = useDispatch();
  const [activeItem, setActiveItem] = useState(selectedItem);
  const [searchText, setSearchText] = useState<string>("");

  const [isFilterByModalVisible, setIsFilterByModalVisible] =
    useState<boolean>(false);
  const [isFilterActive, setIsFilterActive] = useState<boolean>(() =>
    hasActiveFilter(getStoredFilter())
  );

  const [isCopyModalVisible, setIsCopyModalVisible] = useState<any>();
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<any>();
  const [isLeaveModalVisible, setIsLeaveModalVisible] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [isFriendSearchLoading, setIsFriendSearchLoading] = useState(false);
  const [friendResult, setFriendResult] = useState<SelectedSearchItem[]>([]);

  const searchInputRef = useRef<any>(null);
  const searchResultRef = useRef<SelectedSearchItem[]>([]);

  const openInNewWindow = () => {
    window.open(
      window.location.origin + `/map/home`,
      "_blank",
      "toolbar=0,location=0,menubar=0"
    );
  };

  const menu = (
    <ul className="user-dropdown">
      <li>
        <Link to={`/map/home`} target="_blank" className="ml-3 text-white">
          Open New Tab
        </Link>
      </li>
      <li onClick={openInNewWindow}>
        <span className="ml-3">Open New Window</span>
      </li>
    </ul>
  );

  useEffect(() => {
    if (socket.client) {
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getPageFocusSubscriptionTopic(),
        (result)=>{
          console.log("focusresult", result);
        }
      );
      
    }
  }, [socket.client]);

  const [inputValue, setInputValue] = useState<string>("");

  useEffect(() => {
    if (focusItem && !isMobileScreen) {
      // setActiveItem(focusItem);
      console.log("focusItem", focusItem);


      // if (searchInputRef.current) {
      //   // Set the value
      //   searchInputRef.current.input.value = focusItem.pageId;
    
      //   // Create a synthetic event for React
      //   const event = new Event("input", { bubbles: true });
      //   searchInputRef.current.input.dispatchEvent(event);
      // }
      setInputValue(focusItem.pageId);
      setIsSearchLoading(true);
      searchPageRequest(focusItem.pageId);

    }
  }, [focusItem]);

  const handleSearchItemClick = (
    item: SelectedSearchItem,
    closeIframe = true
  ) => {
    setActiveItem(item);
    if (closeIframe) {
      setScreens({
        ...screens,
        map: true,
        message: true,
        rxPanel: false,
        ridePanel: false,
        iframe: false,
        active: "",
      });
    }
    dispatch({ type: "SET_SELECTED_ITEM", payload: item });
    dispatch({
      type: "SET_MESSAGE_FILTER",
      payload: [],
    });
    onPageSelection && onPageSelection(item);
  };

  useEffect(() => {
    if (selectedItem && !isMobileScreen) setActiveItem(selectedItem);
  }, [selectedItem]);

  useEffect(() => {
    setIsSearchLoading(false);
    // Update ref with latest searchResult
    searchResultRef.current = searchResult || [];

    const timerId = setTimeout(() => {
      setIsLoading(false);
    }, 500);
    return () => clearTimeout(timerId);
  }, [searchResult]);

  const handleMapClick = () => {
    dispatch({ type: "SET_MAP_TYPE", payload: "HOME" });
    dispatch({
      type: "SET_ENABLED_FILTER",
      payload: [],
    });
    dispatch({
      type: "SET_SELECTED_FILTER",
      payload: undefined,
    });
    setScreens({ ...screens, map: true });
  };

  const formatAggregateUserResponse = (response) => {
    let resolvedData = [];
    let profiles = [];
    response?.map((user) => {
      if (Array.isArray(user?.profile)) {
        let temp = {
          objectIds: user?.objectId,
          status: user?.status,
          profile: undefined,
          email: undefined,
          phone: undefined,
          profileImage: undefined,
          beamIds: undefined,
          roleId: undefined,
          department: undefined,
        };
        user?.profile.map((x) => {
          const parsed = JSON.parse(x)?.live;
          const admin = JSON.parse(x)?.admin;
          if (parsed?.alternativeIds?.email) {
            temp.email = parsed?.alternativeIds?.email
          }
          if (parsed?.alternativeIds?.phone) {
            temp.phone = parsed?.alternativeIds?.phone
          }
          if (parsed?.profile?.firstName || parsed?.profile?.firstName) {
            temp.profile = parsed?.profile
          }
          if (parsed?.beamIds?.[0]) {
            temp.beamIds = parsed?.beamIds
          }
          if (parsed?.profile?.profileImage?.urls?.original?.url) {
            temp.profileImage = parsed?.profile?.profileImage;
          }
          if (admin?.profile?.roleId) {
            temp.roleId = admin?.profile?.roleId;
          }
        });
        if (temp) {
          profiles.push(temp);
        }
      } else {
        profiles.push({
          objectIds: user.objectId,
          status: user?.status,
          profile: user?.profile?.live?.profile,
          beamIds: user?.profile?.live?.beamIds,
          email: user?.profile?.live?.alternativeIds?.email,
          phone: user?.profile?.live?.alternativeIds?.phone,
          profileImage: user?.profile?.live?.profile?.profileImage,
          roleId: user?.profile?.admin?.profile?.roleId
        });
      }
    });
    try {
      resolvedData = profiles
        ?.filter((user) => {
          return user.email || user.phone || user.beamIds?.[0] || user.profile?.firstName || user.profile?.lastName;
        })
        ?.map((user) => {
          return {
            id: user.objectIds.toString(),
            name:
              user?.profile?.firstName || user.profile?.lastName
                ? (user?.profile?.firstName || "") +
                " " +
                (user.profile?.lastName || "")
                : `user# ${user.objectIds.toString()}`,
            firstName: user?.profile?.firstName ?? "",
            lastName: user?.profile?.lastName ?? "",
            gender: user?.profile?.gender ?? "",
            dob: user?.profile?.dob ?? "",
            email: user.email,
            phone: user.phone,
            beamId:
              user?.beamIds?.[0]?.toLowerCase() ||
              (
                user?.profile?.firstName || user.profile?.lastName
                  ? (user?.profile?.firstName?.toLowerCase() || "") +
                  "." +
                  (user.profile?.lastName?.toLowerCase() || "")
                  : `user# ${user.objectIds.toString()}`
              ),
            profileImage: user?.profileImage ?? {},
            roleId: user?.roleId,
            status: user?.status,
          };
        });
    } catch (e) {
      console.log("something went wrong");
    }

    resolvedData.sort((a, b) => (a.beamId > b.beamId) ? 1 : ((b.beamId > a.beamId) ? -1 : 0))
    return resolvedData;
  };

  const processLastSent = (page) => {
    if (page) {
      let lastSent;
      const groups = page?.persistent?.static?.metadata?.members?.groups ?? {};
      const userGroups = [];
      Object.keys(groups).map((groupName) => {
        if (
          (groups[groupName]?.userIds ?? []).indexOf(
            localStorage.getItem("RID")
          ) !== -1
        )
          userGroups.push(groupName);
      });
      for (let group of ["members", ...userGroups]) {
        if (
          !lastSent ||
          new Date(
            page.nonpersistent?.dynamic?.metadata?.lastSent?.[group]
              ?.updatedAt ?? 1970
          ).getTime() > new Date(lastSent.updatedAt).getTime()
        ) {
          lastSent = page?.nonpersistent?.dynamic?.metadata?.lastSent?.[group];
        }
      }
      page.lastSent = lastSent;
      page.lastRead =
        page?.nonpersistent?.dynamic?.metadata?.lastReadUser?.[
        localStorage.getItem("RID")
        ];
      const memberActivity = Object.keys(
        page?.nonpersistent?.dynamic?.metadata?.lastReadUser ?? {}
      );
      let readBy = {};
      if (memberActivity) {
        memberActivity.map((x) => {
          if (
            page?.nonpersistent?.dynamic?.metadata?.lastReadUser?.[x]
              ?.pageMessageId ??
            false
          ) {
            if (
              !readBy[
              page?.nonpersistent?.dynamic?.metadata?.lastReadUser?.[x]
                ?.pageMessageId
              ]
            )
              readBy[
                page?.nonpersistent?.dynamic?.metadata?.lastReadUser?.[
                  x
                ]?.pageMessageId
              ] = [];
            readBy[
              page?.nonpersistent?.dynamic?.metadata?.lastReadUser?.[x]
                ?.pageMessageId
            ].push(x);
          }
        });
      }
      page.currentUserRole =
        page?.persistent?.static?.metadata?.members?.users?.[
          localStorage.getItem("RID")
        ]?.role ?? "edit";
      page.readBy = readBy;
    }
    return page;
  };

  const processFriendPages = (friendPagesData) => {
    try {
      let resolvedData = friendPagesData.map(
        (page) => {
          return {
            members:
              page?.persistent.static.metadata
                ?.members?.users,
            memberActive: true,
            ...page,
            pageId: page.pageId.toString(),
          };
        }
      );

      console.log("resolvedData", resolvedData);

      resolvedData = resolvedData.map((page) => {
        page = processLastSent(page);
        return page;
      });

      return resolvedData.filter((page) => page);
    } catch (error) {
      console.error("Error processing friend pages:", error);
      return [];
    }
  };

  const mergeFriendPagesWithResults = (friendPages) => {
    const currentResults = searchResultRef.current || [];
    const existingPageIds = new Set(currentResults.map((page: any) => page.pageId));
    
    // Filter out duplicate friend pages
    const newFriendPages = friendPages.filter(
      (page: any) => !existingPageIds.has(page.pageId)
    );

    if (newFriendPages.length > 0) {
      // Combine and sort by lastSent/createdAt
      const combinedResults = [...currentResults, ...newFriendPages].sort(
        (a, b) =>
          (moment(
            b.lastSent?.updatedAt ?? b.persistent.static.metadata.createdAt
          ) as any) -
          (moment(
            a.lastSent?.updatedAt ?? a.persistent.static.metadata.createdAt
          ) as any)
      );

      dispatch({ type: "SET_SEARCH_RESULT", payload: combinedResults });
    }
  };


  const aggregateUser = (inputQueryId: string, filterText?: string) => {
    var searchQuery = `@userType:{user}`;
    if (filterText) {
      if (filterText.length > 2) {
        searchQuery += formatUserFilterText(filterText);
      } else if (filterText.length > 0 && filterText.length <= 2) {
        return;
      }
    }

    setIsFriendSearchLoading(true);

    dispatch(GET_AGGREGATE({
      requestData: {
        select: {
          index: {
            searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
            searchQuery: searchQuery,
            searchOptions: "TIMEOUT 10000",
          },
          list: {
            inputQueryId: inputQueryId,
          },
          load: {
            objectId: "$.objectId",
            liveObject: "$.persistent.static",
            status: "$.nonpersistent.static.live.status",
          },
        },
        groupBy: {
          properties: ["@objectId"],
          reducers: [
            {
              func: "TOLIST",
              arguments: ["@liveObject"],
              name: "profile",
            },
          ],
        },
        apply: {
          expression: "",
          name: "",
        },
        filter: {
          expression: "",
        },
        result: {
          pagination: {
            offset: 0,
            limit: 10000,
          },
        },
        anyStatus: false,
      },
      callback: (response) => {
        const formattedResponse = formatAggregateUserResponse(response);
        const userIds = formattedResponse.map((user: any) => user.id).filter(Boolean);
        const filteredUserIds = userIds.filter(
          (id: string) => id && id !== localStorage.getItem("RID")
        );
        
        // Search friend pages for these users
        if (filteredUserIds.length > 0) {
          searchFriendPages(filteredUserIds);
        }
        else{
          setIsFriendSearchLoading(false);
        }
      },
    }));
  };

  const searchFriendPages = (userIds: string[]) => {
    if (!userIds || userIds.length === 0) return;

    const rid = localStorage.getItem("RID");
    const userIdsQuery = userIds.join("|");
    const searchQuery = `@pageType:{friend}@pageMembers:{${rid}}@pageMembers:{${userIdsQuery}}`;

    dispatch(GET_AGGREGATE({
      requestData: {
        select: {
          index: {
            searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:pageUpdatedAtIndex`,
            searchQuery: searchQuery,
            searchOptions: "TIMEOUT 10000",
          },
          list: {},
          load: {
            pageId: "$.objectId",
            objectStatus: "$.objectStatus",
            persistent: "$.persistent",
            nonpersistent: "$.nonpersistent",
            title: "$.persistent.static.metadata.title",
            createdAt: "$.persistent.static.metadata.createdAt",
            updatedAt: "$.nonpersistent.dynamic.metadata.lastSent.members.updatedAt",
            activeIot: "$.nonpersistent.static.live.activeIot..userId",
            status: "$.nonpersistent.static.live.status.name"
          },
        },
        apply: {
          expression: "",
          name: "",
        },
        filter: {
          expression: "",
        },
        result: {
          pagination: {
            offset: 0,
            limit: 100,
          },
        },
        sortBy: {
          properties: [
            {
              field: "@updatedAt",
              order: "DESC",
            },
          ],
          max: 100,
        },
        anyStatus: false,
      },
      callback: (response) => {
        const processedFriendPages = processFriendPages(response);
        
        // Merge friend pages with existing search results
        if (processedFriendPages.length > 0) {
          mergeFriendPagesWithResults(processedFriendPages);
        }
        setIsFriendSearchLoading(false);
      },
    }));
  };

  const handleClearSearch = () => {
    if (searchTimeout) clearTimeout(searchTimeout);
    setInputValue("");
    setSearchText("");
    setIsSearchLoading(true);
    dispatch({
      type: "SEARCH_PAGE",
      payload: { paginate: false, search: undefined, reset: true },
    });
    searchInputRef.current?.focus();
  };

  const searchPageRequest = (search) => {
    setSearchText(search);
    if (searchTimeout) clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      dispatch({
        type: "SEARCH_PAGE",
        payload: { paginate: false, search, reset: true },
      });
      
      // Aggregate search users if search text length > 2
      if (search && search.length > 2) {
        const inputQueryId = findUsersToPage?.queryId;
        aggregateUser(inputQueryId, search);
      }
    }, 1000);
  };

  const deletePage = (pageId) => {
    sendPageUpdateEvent(pageId, "deletePage", {});
  };

  const sendPageUpdateEvent = (pageId, type, attributes) => {
    const modifyPagePayload: IMessage = getMessageRequestPayload(
      localStorage.getItem("CID"),
      localStorage.getItem("RID"),
      pageId,
      "",
      type,
      attributes
    );
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getModifyPageSubscriptionTopic(pageId),
      wrapRequestPayload(modifyPagePayload)
    );
  };

  const removeUser = (pageId) => {
    sendPageUpdateEvent(pageId, "removePageMember", {
      userId: localStorage.getItem("RID"),
    });
  };

  useEffect(() => {
    if (selectedTab === DashboardTabs.Pages && isMobileScreen) {
      setActiveItem(null);
    }
  });

  

  return (
    <div className="main-column search-panel mr-4">
      <SideBar socket={socket} params={params} onPageCreated={onPageCreated} />
      <div className="main-content">
        <ReactSVG src="/images/next-icon.svg" className="main-next-icon" />
        <div className="search-bar">
          <div className="d-flex">
            <Input
              ref={searchInputRef}
              value={inputValue}
              className="beam-input"
              onChange={(e) => {
                setInputValue(e.target.value);
                setIsSearchLoading(true);
                searchPageRequest(e.target.value);
              }}
              placeholder="Search Pages & Users"
              suffix={
                <span className="search-input-suffix">
                  {inputValue ? (
                    <CloseCircleFilled
                      className="search-clear-icon"
                      onClick={handleClearSearch}
                    />
                  ) : null}
                  <SearchOutlined />
                </span>
              }
            />
            <Button
              className={`beam-btn ml-2${isFilterActive ? " filter-active" : ""}`}
              title={
                isFilterActive
                  ? "Filters are on — results are limited. Click to change."
                  : "Filter"
              }
              onClick={() => setIsFilterByModalVisible(true)}
            >
              <FilterIcon />
            </Button>
            <Button className="beam-btn ml-2" onClick={handleMapClick}>
              <CompassIcon />
            </Button>
          </div>
          {isFilterByModalVisible && (
            <FilterByModal
              isModalVisible={isFilterByModalVisible}
              setIsModalVisible={(visible) => {
                setIsFilterByModalVisible(visible);
                if (!visible) setIsFilterActive(hasActiveFilter(getStoredFilter()));
              }}
              socket={socket}
            />
          )}

          {isCopyModalVisible !== undefined && (
            <CopyPageModal
              isModalVisible={isCopyModalVisible}
              setIsModalVisible={setIsCopyModalVisible}
              socket={socket}
            />
          )}

          {isDeleteModalVisible !== undefined && (
            <ConfirmationModal
              onClose={() => {
                setIsDeleteModalVisible(undefined);
              }}
              message={"Are you sure you want to delete page?"}
              handleConfirm={() => {
                deletePage(isDeleteModalVisible);
                setIsDeleteModalVisible(undefined);
              }}
            />
          )}

          {isLeaveModalVisible !== undefined && (
            <ConfirmationModal
              onClose={() => {
                setIsLeaveModalVisible(undefined);
              }}
              message={"Are you sure you want to leave page?"}
              handleConfirm={() => {
                removeUser(isLeaveModalVisible);
                console.log("remove page here", isLeaveModalVisible);
                dispatch({
                  type: "PAGE_REMOVE",
                  payload: { pageId: isLeaveModalVisible },
                });
                setIsLeaveModalVisible(undefined);
              }}
            />
          )}
        </div>
        {(isSearchLoading || isFriendSearchLoading) && (<div className="loading">
          <Spin className="mt-2" tip="Loading">
            <div className="content" />
          </Spin>
        </div>)}
        <div
          className="main-cards pt-2"
          onScroll={(e: any) => {
            const bottom = isScrollbarAtBottom(e.target);
            if (bottom && searchPage.scroll && !isLoading) {
              setIsLoading(bottom);
              dispatch({ type: "SEARCH_PAGE", payload: { paginate: true } });
            }
          }}
        >
          {searchResult?.map((item: SelectedSearchItem, idx: number) => (
            <SearchCard
              item={item}
              key={idx}
              screens={screens}
              setScreens={setScreens}
              active={item.pageId === activeItem?.pageId}
              onClick={() => handleSearchItemClick(item)}
              calling={item?.nonpersistent?.dynamic?.live?.activeCall?.roomId}
              onCopy={(type, pageId) => {
                setIsCopyModalVisible({ type, pageId });
              }}
              onDelete={(pageId) => {
                setIsDeleteModalVisible(pageId);
              }}
              onLeave={(pageId) => {
                setIsLeaveModalVisible(pageId);
              }}
            />
          ))}
          {isLoading && (<div className="loading">
            <Spin tip="Loading">
              <div className="content" />
            </Spin>
          </div>)}
        </div>
      </div>
    </div>
  );
};

export default SearchPanel;
